import styled from 'styled-components'
import { maxWidth, textAlign } from 'styled-system'
import theme from 'styles/theme'
import { FormDropdown } from 'components/Typography'

const iconChevron = (fill = theme.colors.sagemedium, angle = '-90') => {
  const encodedFill = encodeURIComponent(fill)
  return `"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 24 24'%3E%3Cpath d='M8.4,12l8.3,8.3l-1.4,1.4L5.6,12l9.7-9.7l1.4,1.4L8.4,12z' fill='${encodedFill}' transform='rotate(${angle}, 12, 12)' /%3E%3C/svg%3E"`
}

export const Wrapper = styled.div`
  ${maxWidth}
    margin: ${theme.space[6]} 0;

  ${theme.mediaQueries.small}{
    margin: ${theme.space[2]} 0;
  }
`

export const InputDropdown = styled(FormDropdown).attrs((props) => ({
  disabled: props.isDisabled,
}))`
  ${textAlign}
  border: 1px solid ${(props) => props.theme.colors.sagelightToGreen};
  outline: none;
  transition: border 0.3s ease-in-out;
  width: 100%;
  padding: ${theme.space[2]};
  color: ${(props) => props.theme.colors.sagedarkToGreen};
  box-shadow: 0;
  border-radius: 0;
  margin: 0;
  appearance: none;
  background-color: transparent;
  background-repeat: no-repeat, repeat;
  background-position: right ${theme.space[2]} top 50%, 0 0;
  background-size: 16px;
  background-image: ${(props) =>
    !props.hasError
      ? `url(${iconChevron(props.theme.colors.sagelightToGreen)})`
      : `url(${iconChevron(theme.colors.red)})`};

  html[dir='rtl'] & {
    background-position: left ${theme.space[2]} top 50%, 0 0;
  }

  ${(props) =>
    props.isDisabled &&
    `color: ${theme.colors.sagelight}}; border-color: ${props.theme.colors.sagelightToGreen}}`}

  ${(props) =>
    props.hasError &&
    `color: ${theme.colors.red}}; border-color: ${theme.colors.red}};`}

  ${(props) => props.fixedSize && `height: 60px;`}

  ${(props) =>
    props.centerLabels &&
    `
      text-align: center;
      text-align-last: center;
  `}

  ${(props) =>
    props.uppercase &&
    `
      text-transform: uppercase;
      letter-spacing: 1px;
      font-size: ${theme.fontSizes[2]};

      option {
        text-transform: lowercase;
      }
  `}

  &::-ms-expand {
    display: none;
  }

  &:focus,
  &:active {
    border-color: ${(props) =>
      !props.hasError ? props.theme.colors.sagelightToGreen : theme.colors.red};
  }

  &:hover {
    border-color: ${(props) =>
      !props.hasError
        ? props.theme.colors.sagemediumToRacingGreen
        : theme.colors.red};
  }

  &:disabled {
    background-image: url(${iconChevron(theme.colors.sagelight)});
  }

  &:focus:focus {
    background-image: ${(props) =>
      !props.hasError
        ? `url(${iconChevron(theme.colors.sagelight, '90')})`
        : `url(${iconChevron(theme.colors.red, '90')})`};
  }

`
